import antdTranslations from "antd/lib/locale-provider/en_US";

export default {
   antd: antdTranslations,
   locale: "en"
};
